import { ShieldAlert } from 'lucide-react';

import { useAuth } from '@/features/auth/hooks/useAuth';

/**
 * Wraps the report sections the backend only serves to the platform scope.
 *
 * `finance`, `customers` and `vendors` raise 403 for an `irancharsouq_admin`
 * caller. The tabs already hide those sections, but a hand-typed URL should get
 * a plain explanation instead of a bare error or a blank page.
 */
export default function PlatformOnly({ children }) {
    const { activeRole, loading } = useAuth();

    if (loading) return null;

    if (activeRole !== 'super_admin') {
        return (
            <div className="report-state report-state-error">
                <ShieldAlert size={22} />
                <span>این گزارش فقط برای مدیر کل سامانه در دسترس است.</span>
            </div>
        );
    }

    return children;
}
